import { API_ROOT } from '../../config/config'
import { doDelete, doGet, doPost, doPut, doDownload } from './utils'

export const getMasterAccountType = (name = "", year = "") => {
  const url = `${API_ROOT}/portal/account-type?name=${name}&year=${year}`
  return doGet(url)
}

export const saveMasterAccountType = (request) => {
  const url = `${API_ROOT}/portal/account-type`
  return doPost(url, request)
}

export const updateMasterAccountType = (id, request) => {
  const url = `${API_ROOT}/portal/account-type/${id}`
  return doPut(url, request)
}

export const deleteMasterAccountType = (id) => {
  const url = `${API_ROOT}/portal/account-type/${id}`
  return doDelete(url)
}